"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAuthToken = getAuthToken;
const tslib_1 = require("tslib");
/* eslint-disable import/no-cycle */
const qs_1 = tslib_1.__importDefault(require("qs"));
const errors_deprecated_1 = require("../../errors-deprecated");
const auth_1 = tslib_1.__importDefault(require("./auth"));
const adapter_1 = require("../../../api/adapter");
const JSON_HEADERS = {
    Accept: "application/json",
    "Content-Type": "application/json",
};
const defaultOptions = {
    headers: {},
    failoverUrls: [],
    reauth: false,
    method: "get",
    warnStatuses: [],
    callId: "",
};
async function getAuthToken({ auth, ctx, reauth, }) {
    let token;
    if (reauth) {
        auth.refreshToken();
    }
    try {
        token = await (0, auth_1.default)(auth);
        return token;
    }
    catch (err) {
        const msg = err instanceof Error ? err.message : "unknown error";
        ctx.logger.warn("Authorization error", { err: msg });
        throw err;
    }
}
exports.default = async (ctx, url, options) => {
    var _a, _b, _c, _d;
    const opts = { ...defaultOptions, ...options };
    if (options.auth != null && typeof options.auth.refreshToken !== "function") {
        ctx.logger.error("auth must be a Authorization object");
        throw new Error("auth must be a Authorization object");
    }
    const auth = (_a = opts.auth) !== null && _a !== void 0 ? _a : null;
    const optionsHeaders = (_b = opts.headers) !== null && _b !== void 0 ? _b : {};
    const headers = {
        ...JSON_HEADERS,
        ...optionsHeaders,
    };
    let useUrl = url;
    let failoverUrls = (_d = (_c = opts.failoverUrls) === null || _c === void 0 ? void 0 : _c.slice()) !== null && _d !== void 0 ? _d : [];
    let hasNextUrl = failoverUrls.length > 0;
    const rotateUrl = () => {
        if (failoverUrls[0] == null) {
            throw new Error("Failover URL is undefined");
        }
        [useUrl] = failoverUrls;
        failoverUrls = failoverUrls.slice(1);
        hasNextUrl = failoverUrls.length > 0;
    };
    const request = async (noRetry = false) => {
        var _a, _b;
        let token = null;
        if (auth != null) {
            try {
                token = await getAuthToken({ ctx, auth, reauth: options.reauth });
            }
            catch (err) {
                const msg = err instanceof Error ? err.message : "unknown error";
                ctx.logger.warn("Authorization error", { err: msg });
                throw err;
            }
        }
        const req = {
            method: (_a = options.method) !== null && _a !== void 0 ? _a : "get",
            headers: token != null
                ? {
                    ...headers,
                    Authorization: `bearer ${token}`,
                }
                : headers,
        };
        if (options.body != null) {
            req.body = options.body;
        }
        if (options.query != null) {
            const qs = qs_1.default.stringify(options.query);
            if (useUrl.includes("?")) {
                useUrl = `${useUrl}&${qs}`;
            }
            else {
                useUrl = `${useUrl}?${qs}`;
            }
        }
        let response;
        try {
            response = await adapter_1.device.fetch(useUrl, req);
        }
        catch (err) {
            const msg = err instanceof Error ? err.message : "unknown error";
            ctx.logger.warn("Unable to reach server", {
                useUrl,
                err: msg,
            });
            if (!noRetry && hasNextUrl) {
                rotateUrl();
                return request(failoverUrls.length === 0);
            }
            throw err;
        }
        if (response.status === 204) {
            return null;
        }
        let body;
        try {
            body = await response.json();
        }
        catch (err) {
            let text;
            try {
                text = await response.text();
            }
            catch (e) {
                // ignore
            }
            ctx.logger.warn("Unexpected non-json response from server", {
                useUrl,
                body: text,
                statusCode: response.status,
            });
            if (!noRetry && hasNextUrl) {
                rotateUrl();
                return request(failoverUrls.length === 0);
            }
            throw err;
        }
        if (response.status === 401 || response.status === 403) {
            if (auth != null && !noRetry) {
                try {
                    if (auth.refreshToken()) {
                        return request(true);
                    }
                }
                catch (error) {
                    throw new Error(`Token may be invalid or expired, status code: ${response.status} error: ${error}`);
                }
            }
            ctx.logger.warn("Authorization error from server", {
                useUrl,
                status: response.status,
                reasons: body === null || body === void 0 ? void 0 : body.reasons,
            });
            throw new errors_deprecated_1.NetworkError("Authorization error from server", {
                status: response.status,
            });
        }
        if ((options.expectedStatus != null && response.status !== options.expectedStatus) || response.status !== 200) {
            if (hasNextUrl || ((_b = options.warnStatuses) === null || _b === void 0 ? void 0 : _b.includes(response.status))) {
                ctx.logger.warn("Unexpected response code from server", {
                    useUrl,
                    status: response.status,
                    reasons: body === null || body === void 0 ? void 0 : body.reasons,
                });
            }
            else {
                ctx.logger.error("Unexpected response code from server", {
                    useUrl,
                    status: response.status,
                    reasons: body === null || body === void 0 ? void 0 : body.reasons,
                });
            }
            const e = new errors_deprecated_1.NetworkError("Unexpected response code from server", {
                status: response.status,
            });
            if (!noRetry && hasNextUrl) {
                rotateUrl();
                return request(failoverUrls.length === 0);
            }
            throw e;
        }
        return {
            authToken: token,
            body,
            status: response.status,
        };
    };
    return request();
};
//# sourceMappingURL=request.js.map